// Ubicación en el repo: src/components/BrandsList.jsx
// Administración de marcas de producto (Fase A del módulo de Inventario/
// Contabilidad, migración 0046, 24-ago-2026) — sub-pestaña de
// Catalog.jsx. Mismo patrón que CategoriesList.jsx.
import { useCallback, useEffect, useState } from 'react';
import { listAllBrandsForAdmin, softDeleteBrand, restoreBrand } from '../lib/brands';
import BrandFormModal from './BrandFormModal';
import Spinner from './Spinner';

export default function BrandsList({ actorId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [editTarget, setEditTarget] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setItems(await listAllBrandsForAdmin());
    } catch (err) {
      setError(err.message || 'No se pudo cargar las marcas.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  async function handleToggleActive(item) {
    const action = item.deleted_at ? 'reactivar' : 'desactivar';
    const ok = window.confirm(`¿${action === 'reactivar' ? 'Reactivar' : 'Desactivar'} "${item.name}"?`);
    if (!ok) return;
    try {
      if (item.deleted_at) {
        await restoreBrand(item.id);
      } else {
        await softDeleteBrand(item.id, actorId);
      }
      refresh();
    } catch (err) {
      setError(err.message || `No se pudo ${action} la marca.`);
    }
  }

  return (
    <div>
      <div className="patients-page__toolbar">
        <h2 style={{ margin: 0 }}>Marcas</h2>
        <div className="patients-page__toolbar-right">
          <button
            type="button"
            className="button-primary"
            onClick={() => {
              setEditTarget(null);
              setFormOpen(true);
            }}
          >
            + Nueva marca
          </button>
        </div>
      </div>

      {error && <p className="auth-error">{error}</p>}

      <table className="patients-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={3}><Spinner inline /></td>
            </tr>
          ) : items.length === 0 ? (
            <tr>
              <td colSpan={3}>No hay marcas registradas todavía.</td>
            </tr>
          ) : (
            items.map((b) => (
              <tr key={b.id}>
                <td>{b.name}</td>
                <td>
                  {b.deleted_at ? (
                    <span className="badge badge-danger">Inactiva</span>
                  ) : (
                    <span className="badge badge-ok">Activa</span>
                  )}
                </td>
                <td className="actions-cell">
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => {
                      setEditTarget(b);
                      setFormOpen(true);
                    }}
                  >
                    Editar
                  </button>
                  <button
                    type="button"
                    className={`link-button ${b.deleted_at ? '' : 'link-button--danger'}`}
                    onClick={() => handleToggleActive(b)}
                  >
                    {b.deleted_at ? 'Reactivar' : 'Desactivar'}
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {formOpen && (
        <BrandFormModal
          brand={editTarget}
          onClose={() => {
            setFormOpen(false);
            setEditTarget(null);
          }}
          onSaved={() => {
            setFormOpen(false);
            setEditTarget(null);
            refresh();
          }}
        />
      )}
    </div>
  );
}
